import classnames from 'classnames'
import React, { PropsWithChildren } from 'react'
import { Icon } from '@atoms'

export type DashboardWidgetProps = PropsWithChildren

export const DashboardWidget: React.FC<DashboardWidgetProps> = ({
    children,
}) => {
    const baseStyles =
        'flex h-widgetHeight w-full flex-col overflow-hidden rounded-xl py-2 gap-2 shadow-sm'

    const variants: DashboardWidgetVariants = {
        empty: {
            default: 'bg-neutral-50 text-neutral-400',
            hover: 'hover:bg-blue-50 hover:text-blue-500',
            active: 'active:bg-blue-100 active:text-blue-600',
        },
        filled: {
            default: 'bg-white text-subtle',
            hover: 'hover:bg-neutral-50 hover:text-subtle',
            active: 'active:bg-neutral-100 active:text-subtle',
        },
    }

    const variantName = !children ? 'empty' : 'filled'

    const variantObj = variants[variantName]

    const className = classnames(
        baseStyles,
        variantObj.default,
        variantObj.hover,
        variantObj.active
    )

    if (children) {
        return (
            <div className={className} data-testid="card-container">
                {children}
            </div>
        )
    }

    return (
        <div className={className} data-testid="card-container">
            <button
                onClick={() => {}}
                className="flex flex-1 flex-col items-center justify-center p-4"
            >
                <Icon
                    name="add_circle"
                    size="medium"
                    data-testid="empty-card-icon"
                />
            </button>
        </div>
    )
}

export type DashboardWidgetVariants = {
    empty: {
        default: string
        hover: string
        active: string
    }
    filled: {
        default: string
        hover: string
        active: string
    }
}
